module.exports = __webpack_public_path__ + "static/media/img_prn47.53fe580d.png";